import { parsePhoneNumber, PhoneNumber } from 'libphonenumber-js';

export function isUsOrCaPhoneNumber(phone: string): boolean {
  if (!phone) {
    return false;
  }

  try {
    const parsedPhone: PhoneNumber = parsePhoneNumber(phone);

    return ['US', 'CA'].includes(parsedPhone.country);
  } catch(error) {
    return false;
  }
}